import { Group, TextInput, Modal, Text, Center, Title } from '@mantine/core';
import { IconBadgeVr, IconSearch } from '@tabler/icons-react';
import React from 'react';
import DataTable from 'react-data-table-component';
import UserRow from '../../users/components/UserRow';
import { useNavigate } from "react-router-dom";
import useGetUser from "./useGetUser";
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';
import ActionCell from '../../users/components/ActionCell';

const Remote = () => {

    const navigate = useNavigate();
    const { themeQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch
    } = useGetUser()
    console.log({ data });
    const columns = [
        {
            name: 'First Name',
            selector: row => row.tiktok_username,
            sortable: true,
            cell: row => <UserRow row={row} />,
            width: "300px",
        },

        {
            name: 'Email',
            selector: row => <Group>

                {row.email}

                {((row.is_email_verified == true) ? <IconBadgeVr size={22} color='green' /> : "")}
            </Group>
            ,
            width: "300px",

            sortable: true,
        },

        {
            name: 'Country',
            selector: row => row.country,
            sortable: true,
        },

        {
            name: 'Action',
            cell: row => <ActionCell row={row} />,

        },
    ];




    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Users</Title>
                <TextInput type='search' defaultValue={search} onChange={(event) => setSearch(event?.target?.value)} placeholder='Search' leftSection={<IconSearch size={18} />} style={{ alignSelf: "flex-end" }} />
            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}

            // selectableRows

            />
        </LoadingErrorContainer>
    );
};


export default Remote
